import * as i0 from '@angular/core';
import { Component, SkipSelf, Host, Input, NgModule, ContentChildren, Output, Inject } from '@angular/core';
import * as i1 from 'devextreme-angular/core';
import { NestedOption, NestedOptionHost, DxIntegrationModule, CollectionNestedOption, extractTemplate, DxTemplateHost } from 'devextreme-angular/core';
import { PROPERTY_TOKEN_buttons, PROPERTY_TOKEN_toolbarItems } from 'devextreme-angular/core/tokens';
import { DOCUMENT } from '@angular/common';

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
const _c0 = ["*"];
let DxoDropDownBoxAnimationComponent = /*#__PURE__*/(() => {
  class DxoDropDownBoxAnimationComponent extends NestedOption {
    get hide() {
      return this._getOption('hide');
    }
    set hide(value) {
      this._setOption('hide', value);
    }
    get show() {
      return this._getOption('show');
    }
    set show(value) {
      this._setOption('show', value);
    }
    get _optionPath() {
      return 'animation';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDropDownBoxAnimationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownBoxAnimationComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDropDownBoxAnimationComponent,
      selectors: [["dxo-drop-down-box-animation"]],
      inputs: {
        hide: "hide",
        show: "show"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDropDownBoxAnimationComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDropDownBoxAnimationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDropDownBoxAnimationModule = /*#__PURE__*/(() => {
  class DxoDropDownBoxAnimationModule {
    /** @nocollapse */static ɵfac = function DxoDropDownBoxAnimationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownBoxAnimationModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDropDownBoxAnimationModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDropDownBoxAnimationComponent]
    });
  }
  return DxoDropDownBoxAnimationModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDropDownBoxAtComponent = /*#__PURE__*/(() => {
  class DxoDropDownBoxAtComponent extends NestedOption {
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'at';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDropDownBoxAtComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownBoxAtComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDropDownBoxAtComponent,
      selectors: [["dxo-drop-down-box-at"]],
      inputs: {
        x: "x",
        y: "y"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDropDownBoxAtComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDropDownBoxAtComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDropDownBoxAtModule = /*#__PURE__*/(() => {
  class DxoDropDownBoxAtModule {
    /** @nocollapse */static ɵfac = function DxoDropDownBoxAtModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownBoxAtModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDropDownBoxAtModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDropDownBoxAtComponent]
    });
  }
  return DxoDropDownBoxAtModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDropDownBoxBoundaryOffsetComponent = /*#__PURE__*/(() => {
  class DxoDropDownBoxBoundaryOffsetComponent extends NestedOption {
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'boundaryOffset';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDropDownBoxBoundaryOffsetComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownBoxBoundaryOffsetComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDropDownBoxBoundaryOffsetComponent,
      selectors: [["dxo-drop-down-box-boundary-offset"]],
      inputs: {
        x: "x",
        y: "y"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDropDownBoxBoundaryOffsetComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDropDownBoxBoundaryOffsetComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDropDownBoxBoundaryOffsetModule = /*#__PURE__*/(() => {
  class DxoDropDownBoxBoundaryOffsetModule {
    /** @nocollapse */static ɵfac = function DxoDropDownBoxBoundaryOffsetModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownBoxBoundaryOffsetModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDropDownBoxBoundaryOffsetModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDropDownBoxBoundaryOffsetComponent]
    });
  }
  return DxoDropDownBoxBoundaryOffsetModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiDropDownBoxButtonComponent = /*#__PURE__*/(() => {
  class DxiDropDownBoxButtonComponent extends CollectionNestedOption {
    get location() {
      return this._getOption('location');
    }
    set location(value) {
      this._setOption('location', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get options() {
      return this._getOption('options');
    }
    set options(value) {
      this._setOption('options', value);
    }
    get _optionPath() {
      return 'buttons';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiDropDownBoxButtonComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDropDownBoxButtonComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiDropDownBoxButtonComponent,
      selectors: [["dxi-drop-down-box-button"]],
      inputs: {
        location: "location",
        name: "name",
        options: "options"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_buttons,
        useExisting: DxiDropDownBoxButtonComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiDropDownBoxButtonComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiDropDownBoxButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiDropDownBoxButtonModule = /*#__PURE__*/(() => {
  class DxiDropDownBoxButtonModule {
    /** @nocollapse */static ɵfac = function DxiDropDownBoxButtonModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDropDownBoxButtonModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiDropDownBoxButtonModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiDropDownBoxButtonComponent]
    });
  }
  return DxiDropDownBoxButtonModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDropDownBoxCollisionComponent = /*#__PURE__*/(() => {
  class DxoDropDownBoxCollisionComponent extends NestedOption {
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'collision';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDropDownBoxCollisionComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownBoxCollisionComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDropDownBoxCollisionComponent,
      selectors: [["dxo-drop-down-box-collision"]],
      inputs: {
        x: "x",
        y: "y"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDropDownBoxCollisionComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDropDownBoxCollisionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDropDownBoxCollisionModule = /*#__PURE__*/(() => {
  class DxoDropDownBoxCollisionModule {
    /** @nocollapse */static ɵfac = function DxoDropDownBoxCollisionModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownBoxCollisionModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDropDownBoxCollisionModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDropDownBoxCollisionComponent]
    });
  }
  return DxoDropDownBoxCollisionModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDropDownBoxDropDownOptionsComponent = /*#__PURE__*/(() => {
  class DxoDropDownBoxDropDownOptionsComponent extends NestedOption {
    set _toolbarItemsContentChildren(value) {
      this.setChildren('toolbarItems', value);
    }
    get accessKey() {
      return this._getOption('accessKey');
    }
    set accessKey(value) {
      this._setOption('accessKey', value);
    }
    get animation() {
      return this._getOption('animation');
    }
    set animation(value) {
      this._setOption('animation', value);
    }
    get container() {
      return this._getOption('container');
    }
    set container(value) {
      this._setOption('container', value);
    }
    get contentTemplate() {
      return this._getOption('contentTemplate');
    }
    set contentTemplate(value) {
      this._setOption('contentTemplate', value);
    }
    get deferRendering() {
      return this._getOption('deferRendering');
    }
    set deferRendering(value) {
      this._setOption('deferRendering', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get dragAndResizeArea() {
      return this._getOption('dragAndResizeArea');
    }
    set dragAndResizeArea(value) {
      this._setOption('dragAndResizeArea', value);
    }
    get dragEnabled() {
      return this._getOption('dragEnabled');
    }
    set dragEnabled(value) {
      this._setOption('dragEnabled', value);
    }
    get dragOutsideBoundary() {
      return this._getOption('dragOutsideBoundary');
    }
    set dragOutsideBoundary(value) {
      this._setOption('dragOutsideBoundary', value);
    }
    get enableBodyScroll() {
      return this._getOption('enableBodyScroll');
    }
    set enableBodyScroll(value) {
      this._setOption('enableBodyScroll', value);
    }
    get focusStateEnabled() {
      return this._getOption('focusStateEnabled');
    }
    set focusStateEnabled(value) {
      this._setOption('focusStateEnabled', value);
    }
    get fullScreen() {
      return this._getOption('fullScreen');
    }
    set fullScreen(value) {
      this._setOption('fullScreen', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get hideOnOutsideClick() {
      return this._getOption('hideOnOutsideClick');
    }
    set hideOnOutsideClick(value) {
      this._setOption('hideOnOutsideClick', value);
    }
    get hideOnParentScroll() {
      return this._getOption('hideOnParentScroll');
    }
    set hideOnParentScroll(value) {
      this._setOption('hideOnParentScroll', value);
    }
    get hint() {
      return this._getOption('hint');
    }
    set hint(value) {
      this._setOption('hint', value);
    }
    get hoverStateEnabled() {
      return this._getOption('hoverStateEnabled');
    }
    set hoverStateEnabled(value) {
      this._setOption('hoverStateEnabled', value);
    }
    get maxHeight() {
      return this._getOption('maxHeight');
    }
    set maxHeight(value) {
      this._setOption('maxHeight', value);
    }
    get maxWidth() {
      return this._getOption('maxWidth');
    }
    set maxWidth(value) {
      this._setOption('maxWidth', value);
    }
    get minHeight() {
      return this._getOption('minHeight');
    }
    set minHeight(value) {
      this._setOption('minHeight', value);
    }
    get minWidth() {
      return this._getOption('minWidth');
    }
    set minWidth(value) {
      this._setOption('minWidth', value);
    }
    get onContentReady() {
      return this._getOption('onContentReady');
    }
    set onContentReady(value) {
      this._setOption('onContentReady', value);
    }
    get onDisposing() {
      return this._getOption('onDisposing');
    }
    set onDisposing(value) {
      this._setOption('onDisposing', value);
    }
    get onHidden() {
      return this._getOption('onHidden');
    }
    set onHidden(value) {
      this._setOption('onHidden', value);
    }
    get onHiding() {
      return this._getOption('onHiding');
    }
    set onHiding(value) {
      this._setOption('onHiding', value);
    }
    get onInitialized() {
      return this._getOption('onInitialized');
    }
    set onInitialized(value) {
      this._setOption('onInitialized', value);
    }
    get onOptionChanged() {
      return this._getOption('onOptionChanged');
    }
    set onOptionChanged(value) {
      this._setOption('onOptionChanged', value);
    }
    get onResize() {
      return this._getOption('onResize');
    }
    set onResize(value) {
      this._setOption('onResize', value);
    }
    get onResizeEnd() {
      return this._getOption('onResizeEnd');
    }
    set onResizeEnd(value) {
      this._setOption('onResizeEnd', value);
    }
    get onResizeStart() {
      return this._getOption('onResizeStart');
    }
    set onResizeStart(value) {
      this._setOption('onResizeStart', value);
    }
    get onShowing() {
      return this._getOption('onShowing');
    }
    set onShowing(value) {
      this._setOption('onShowing', value);
    }
    get onShown() {
      return this._getOption('onShown');
    }
    set onShown(value) {
      this._setOption('onShown', value);
    }
    get onTitleRendered() {
      return this._getOption('onTitleRendered');
    }
    set onTitleRendered(value) {
      this._setOption('onTitleRendered', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get resizeEnabled() {
      return this._getOption('resizeEnabled');
    }
    set resizeEnabled(value) {
      this._setOption('resizeEnabled', value);
    }
    get restorePosition() {
      return this._getOption('restorePosition');
    }
    set restorePosition(value) {
      this._setOption('restorePosition', value);
    }
    get rtlEnabled() {
      return this._getOption('rtlEnabled');
    }
    set rtlEnabled(value) {
      this._setOption('rtlEnabled', value);
    }
    get shading() {
      return this._getOption('shading');
    }
    set shading(value) {
      this._setOption('shading', value);
    }
    get shadingColor() {
      return this._getOption('shadingColor');
    }
    set shadingColor(value) {
      this._setOption('shadingColor', value);
    }
    get showCloseButton() {
      return this._getOption('showCloseButton');
    }
    set showCloseButton(value) {
      this._setOption('showCloseButton', value);
    }
    get showTitle() {
      return this._getOption('showTitle');
    }
    set showTitle(value) {
      this._setOption('showTitle', value);
    }
    get tabIndex() {
      return this._getOption('tabIndex');
    }
    set tabIndex(value) {
      this._setOption('tabIndex', value);
    }
    get title() {
      return this._getOption('title');
    }
    set title(value) {
      this._setOption('title', value);
    }
    get titleTemplate() {
      return this._getOption('titleTemplate');
    }
    set titleTemplate(value) {
      this._setOption('titleTemplate', value);
    }
    get toolbarItems() {
      return this._getOption('toolbarItems');
    }
    set toolbarItems(value) {
      this._setOption('toolbarItems', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get wrapperAttr() {
      return this._getOption('wrapperAttr');
    }
    set wrapperAttr(value) {
      this._setOption('wrapperAttr', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    heightChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    positionChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    visibleChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    widthChange;
    get _optionPath() {
      return 'dropDownOptions';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'heightChange'
      }, {
        emit: 'positionChange'
      }, {
        emit: 'visibleChange'
      }, {
        emit: 'widthChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDropDownBoxDropDownOptionsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownBoxDropDownOptionsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDropDownBoxDropDownOptionsComponent,
      selectors: [["dxo-drop-down-box-drop-down-options"]],
      contentQueries: function DxoDropDownBoxDropDownOptionsComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_toolbarItems, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._toolbarItemsContentChildren = _t);
        }
      },
      inputs: {
        accessKey: "accessKey",
        animation: "animation",
        container: "container",
        contentTemplate: "contentTemplate",
        deferRendering: "deferRendering",
        disabled: "disabled",
        dragAndResizeArea: "dragAndResizeArea",
        dragEnabled: "dragEnabled",
        dragOutsideBoundary: "dragOutsideBoundary",
        enableBodyScroll: "enableBodyScroll",
        focusStateEnabled: "focusStateEnabled",
        fullScreen: "fullScreen",
        height: "height",
        hideOnOutsideClick: "hideOnOutsideClick",
        hideOnParentScroll: "hideOnParentScroll",
        hint: "hint",
        hoverStateEnabled: "hoverStateEnabled",
        maxHeight: "maxHeight",
        maxWidth: "maxWidth",
        minHeight: "minHeight",
        minWidth: "minWidth",
        onContentReady: "onContentReady",
        onDisposing: "onDisposing",
        onHidden: "onHidden",
        onHiding: "onHiding",
        onInitialized: "onInitialized",
        onOptionChanged: "onOptionChanged",
        onResize: "onResize",
        onResizeEnd: "onResizeEnd",
        onResizeStart: "onResizeStart",
        onShowing: "onShowing",
        onShown: "onShown",
        onTitleRendered: "onTitleRendered",
        position: "position",
        resizeEnabled: "resizeEnabled",
        restorePosition: "restorePosition",
        rtlEnabled: "rtlEnabled",
        shading: "shading",
        shadingColor: "shadingColor",
        showCloseButton: "showCloseButton",
        showTitle: "showTitle",
        tabIndex: "tabIndex",
        title: "title",
        titleTemplate: "titleTemplate",
        toolbarItems: "toolbarItems",
        visible: "visible",
        width: "width",
        wrapperAttr: "wrapperAttr"
      },
      outputs: {
        heightChange: "heightChange",
        positionChange: "positionChange",
        visibleChange: "visibleChange",
        widthChange: "widthChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDropDownBoxDropDownOptionsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDropDownBoxDropDownOptionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDropDownBoxDropDownOptionsModule = /*#__PURE__*/(() => {
  class DxoDropDownBoxDropDownOptionsModule {
    /** @nocollapse */static ɵfac = function DxoDropDownBoxDropDownOptionsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownBoxDropDownOptionsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDropDownBoxDropDownOptionsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDropDownBoxDropDownOptionsComponent]
    });
  }
  return DxoDropDownBoxDropDownOptionsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDropDownBoxFromComponent = /*#__PURE__*/(() => {
  class DxoDropDownBoxFromComponent extends NestedOption {
    get left() {
      return this._getOption('left');
    }
    set left(value) {
      this._setOption('left', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get scale() {
      return this._getOption('scale');
    }
    set scale(value) {
      this._setOption('scale', value);
    }
    get top() {
      return this._getOption('top');
    }
    set top(value) {
      this._setOption('top', value);
    }
    get _optionPath() {
      return 'from';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDropDownBoxFromComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownBoxFromComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDropDownBoxFromComponent,
      selectors: [["dxo-drop-down-box-from"]],
      inputs: {
        left: "left",
        opacity: "opacity",
        position: "position",
        scale: "scale",
        top: "top"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDropDownBoxFromComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDropDownBoxFromComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDropDownBoxFromModule = /*#__PURE__*/(() => {
  class DxoDropDownBoxFromModule {
    /** @nocollapse */static ɵfac = function DxoDropDownBoxFromModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownBoxFromModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDropDownBoxFromModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDropDownBoxFromComponent]
    });
  }
  return DxoDropDownBoxFromModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDropDownBoxHideComponent = /*#__PURE__*/(() => {
  class DxoDropDownBoxHideComponent extends NestedOption {
    get complete() {
      return this._getOption('complete');
    }
    set complete(value) {
      this._setOption('complete', value);
    }
    get delay() {
      return this._getOption('delay');
    }
    set delay(value) {
      this._setOption('delay', value);
    }
    get direction() {
      return this._getOption('direction');
    }
    set direction(value) {
      this._setOption('direction', value);
    }
    get duration() {
      return this._getOption('duration');
    }
    set duration(value) {
      this._setOption('duration', value);
    }
    get easing() {
      return this._getOption('easing');
    }
    set easing(value) {
      this._setOption('easing', value);
    }
    get from() {
      return this._getOption('from');
    }
    set from(value) {
      this._setOption('from', value);
    }
    get staggerDelay() {
      return this._getOption('staggerDelay');
    }
    set staggerDelay(value) {
      this._setOption('staggerDelay', value);
    }
    get start() {
      return this._getOption('start');
    }
    set start(value) {
      this._setOption('start', value);
    }
    get to() {
      return this._getOption('to');
    }
    set to(value) {
      this._setOption('to', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get _optionPath() {
      return 'hide';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDropDownBoxHideComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownBoxHideComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDropDownBoxHideComponent,
      selectors: [["dxo-drop-down-box-hide"]],
      inputs: {
        complete: "complete",
        delay: "delay",
        direction: "direction",
        duration: "duration",
        easing: "easing",
        from: "from",
        staggerDelay: "staggerDelay",
        start: "start",
        to: "to",
        type: "type"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDropDownBoxHideComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDropDownBoxHideComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDropDownBoxHideModule = /*#__PURE__*/(() => {
  class DxoDropDownBoxHideModule {
    /** @nocollapse */static ɵfac = function DxoDropDownBoxHideModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownBoxHideModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDropDownBoxHideModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDropDownBoxHideComponent]
    });
  }
  return DxoDropDownBoxHideModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDropDownBoxMyComponent = /*#__PURE__*/(() => {
  class DxoDropDownBoxMyComponent extends NestedOption {
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'my';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDropDownBoxMyComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownBoxMyComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDropDownBoxMyComponent,
      selectors: [["dxo-drop-down-box-my"]],
      inputs: {
        x: "x",
        y: "y"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDropDownBoxMyComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDropDownBoxMyComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDropDownBoxMyModule = /*#__PURE__*/(() => {
  class DxoDropDownBoxMyModule {
    /** @nocollapse */static ɵfac = function DxoDropDownBoxMyModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownBoxMyModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDropDownBoxMyModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDropDownBoxMyComponent]
    });
  }
  return DxoDropDownBoxMyModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDropDownBoxOffsetComponent = /*#__PURE__*/(() => {
  class DxoDropDownBoxOffsetComponent extends NestedOption {
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'offset';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDropDownBoxOffsetComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownBoxOffsetComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDropDownBoxOffsetComponent,
      selectors: [["dxo-drop-down-box-offset"]],
      inputs: {
        x: "x",
        y: "y"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDropDownBoxOffsetComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDropDownBoxOffsetComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDropDownBoxOffsetModule = /*#__PURE__*/(() => {
  class DxoDropDownBoxOffsetModule {
    /** @nocollapse */static ɵfac = function DxoDropDownBoxOffsetModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownBoxOffsetModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDropDownBoxOffsetModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDropDownBoxOffsetComponent]
    });
  }
  return DxoDropDownBoxOffsetModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDropDownBoxOptionsComponent = /*#__PURE__*/(() => {
  class DxoDropDownBoxOptionsComponent extends NestedOption {
    renderer;
    document;
    element;
    get accessKey() {
      return this._getOption('accessKey');
    }
    set accessKey(value) {
      this._setOption('accessKey', value);
    }
    get activeStateEnabled() {
      return this._getOption('activeStateEnabled');
    }
    set activeStateEnabled(value) {
      this._setOption('activeStateEnabled', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get elementAttr() {
      return this._getOption('elementAttr');
    }
    set elementAttr(value) {
      this._setOption('elementAttr', value);
    }
    get focusStateEnabled() {
      return this._getOption('focusStateEnabled');
    }
    set focusStateEnabled(value) {
      this._setOption('focusStateEnabled', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get hint() {
      return this._getOption('hint');
    }
    set hint(value) {
      this._setOption('hint', value);
    }
    get hoverStateEnabled() {
      return this._getOption('hoverStateEnabled');
    }
    set hoverStateEnabled(value) {
      this._setOption('hoverStateEnabled', value);
    }
    get icon() {
      return this._getOption('icon');
    }
    set icon(value) {
      this._setOption('icon', value);
    }
    get onClick() {
      return this._getOption('onClick');
    }
    set onClick(value) {
      this._setOption('onClick', value);
    }
    get onContentReady() {
      return this._getOption('onContentReady');
    }
    set onContentReady(value) {
      this._setOption('onContentReady', value);
    }
    get onDisposing() {
      return this._getOption('onDisposing');
    }
    set onDisposing(value) {
      this._setOption('onDisposing', value);
    }
    get onInitialized() {
      return this._getOption('onInitialized');
    }
    set onInitialized(value) {
      this._setOption('onInitialized', value);
    }
    get onOptionChanged() {
      return this._getOption('onOptionChanged');
    }
    set onOptionChanged(value) {
      this._setOption('onOptionChanged', value);
    }
    get rtlEnabled() {
      return this._getOption('rtlEnabled');
    }
    set rtlEnabled(value) {
      this._setOption('rtlEnabled', value);
    }
    get stylingMode() {
      return this._getOption('stylingMode');
    }
    set stylingMode(value) {
      this._setOption('stylingMode', value);
    }
    get tabIndex() {
      return this._getOption('tabIndex');
    }
    set tabIndex(value) {
      this._setOption('tabIndex', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get useSubmitBehavior() {
      return this._getOption('useSubmitBehavior');
    }
    set useSubmitBehavior(value) {
      this._setOption('useSubmitBehavior', value);
    }
    get validationGroup() {
      return this._getOption('validationGroup');
    }
    set validationGroup(value) {
      this._setOption('validationGroup', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'options';
    }
    constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
      super();
      this.renderer = renderer;
      this.document = document;
      this.element = element;
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      templateHost.setHost(this);
    }
    setTemplate(template) {
      this.template = template;
    }
    ngAfterViewInit() {
      extractTemplate(this, this.element, this.renderer, this.document);
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDropDownBoxOptionsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownBoxOptionsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDropDownBoxOptionsComponent,
      selectors: [["dxo-drop-down-box-options"]],
      inputs: {
        accessKey: "accessKey",
        activeStateEnabled: "activeStateEnabled",
        disabled: "disabled",
        elementAttr: "elementAttr",
        focusStateEnabled: "focusStateEnabled",
        height: "height",
        hint: "hint",
        hoverStateEnabled: "hoverStateEnabled",
        icon: "icon",
        onClick: "onClick",
        onContentReady: "onContentReady",
        onDisposing: "onDisposing",
        onInitialized: "onInitialized",
        onOptionChanged: "onOptionChanged",
        rtlEnabled: "rtlEnabled",
        stylingMode: "stylingMode",
        tabIndex: "tabIndex",
        template: "template",
        text: "text",
        type: "type",
        useSubmitBehavior: "useSubmitBehavior",
        validationGroup: "validationGroup",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function DxoDropDownBoxOptionsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      dependencies: [DxIntegrationModule],
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
  return DxoDropDownBoxOptionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDropDownBoxOptionsModule = /*#__PURE__*/(() => {
  class DxoDropDownBoxOptionsModule {
    /** @nocollapse */static ɵfac = function DxoDropDownBoxOptionsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownBoxOptionsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDropDownBoxOptionsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDropDownBoxOptionsComponent]
    });
  }
  return DxoDropDownBoxOptionsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDropDownBoxPositionComponent = /*#__PURE__*/(() => {
  class DxoDropDownBoxPositionComponent extends NestedOption {
    get at() {
      return this._getOption('at');
    }
    set at(value) {
      this._setOption('at', value);
    }
    get boundary() {
      return this._getOption('boundary');
    }
    set boundary(value) {
      this._setOption('boundary', value);
    }
    get boundaryOffset() {
      return this._getOption('boundaryOffset');
    }
    set boundaryOffset(value) {
      this._setOption('boundaryOffset', value);
    }
    get collision() {
      return this._getOption('collision');
    }
    set collision(value) {
      this._setOption('collision', value);
    }
    get my() {
      return this._getOption('my');
    }
    set my(value) {
      this._setOption('my', value);
    }
    get of() {
      return this._getOption('of');
    }
    set of(value) {
      this._setOption('of', value);
    }
    get offset() {
      return this._getOption('offset');
    }
    set offset(value) {
      this._setOption('offset', value);
    }
    get _optionPath() {
      return 'position';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDropDownBoxPositionComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownBoxPositionComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDropDownBoxPositionComponent,
      selectors: [["dxo-drop-down-box-position"]],
      inputs: {
        at: "at",
        boundary: "boundary",
        boundaryOffset: "boundaryOffset",
        collision: "collision",
        my: "my",
        of: "of",
        offset: "offset"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDropDownBoxPositionComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDropDownBoxPositionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDropDownBoxPositionModule = /*#__PURE__*/(() => {
  class DxoDropDownBoxPositionModule {
    /** @nocollapse */static ɵfac = function DxoDropDownBoxPositionModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownBoxPositionModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDropDownBoxPositionModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDropDownBoxPositionComponent]
    });
  }
  return DxoDropDownBoxPositionModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDropDownBoxShowComponent = /*#__PURE__*/(() => {
  class DxoDropDownBoxShowComponent extends NestedOption {
    get complete() {
      return this._getOption('complete');
    }
    set complete(value) {
      this._setOption('complete', value);
    }
    get delay() {
      return this._getOption('delay');
    }
    set delay(value) {
      this._setOption('delay', value);
    }
    get direction() {
      return this._getOption('direction');
    }
    set direction(value) {
      this._setOption('direction', value);
    }
    get duration() {
      return this._getOption('duration');
    }
    set duration(value) {
      this._setOption('duration', value);
    }
    get easing() {
      return this._getOption('easing');
    }
    set easing(value) {
      this._setOption('easing', value);
    }
    get from() {
      return this._getOption('from');
    }
    set from(value) {
      this._setOption('from', value);
    }
    get staggerDelay() {
      return this._getOption('staggerDelay');
    }
    set staggerDelay(value) {
      this._setOption('staggerDelay', value);
    }
    get start() {
      return this._getOption('start');
    }
    set start(value) {
      this._setOption('start', value);
    }
    get to() {
      return this._getOption('to');
    }
    set to(value) {
      this._setOption('to', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get _optionPath() {
      return 'show';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDropDownBoxShowComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownBoxShowComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDropDownBoxShowComponent,
      selectors: [["dxo-drop-down-box-show"]],
      inputs: {
        complete: "complete",
        delay: "delay",
        direction: "direction",
        duration: "duration",
        easing: "easing",
        from: "from",
        staggerDelay: "staggerDelay",
        start: "start",
        to: "to",
        type: "type"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDropDownBoxShowComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDropDownBoxShowComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDropDownBoxShowModule = /*#__PURE__*/(() => {
  class DxoDropDownBoxShowModule {
    /** @nocollapse */static ɵfac = function DxoDropDownBoxShowModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownBoxShowModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDropDownBoxShowModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDropDownBoxShowComponent]
    });
  }
  return DxoDropDownBoxShowModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDropDownBoxToComponent = /*#__PURE__*/(() => {
  class DxoDropDownBoxToComponent extends NestedOption {
    get left() {
      return this._getOption('left');
    }
    set left(value) {
      this._setOption('left', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get scale() {
      return this._getOption('scale');
    }
    set scale(value) {
      this._setOption('scale', value);
    }
    get top() {
      return this._getOption('top');
    }
    set top(value) {
      this._setOption('top', value);
    }
    get _optionPath() {
      return 'to';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDropDownBoxToComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownBoxToComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDropDownBoxToComponent,
      selectors: [["dxo-drop-down-box-to"]],
      inputs: {
        left: "left",
        opacity: "opacity",
        position: "position",
        scale: "scale",
        top: "top"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDropDownBoxToComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDropDownBoxToComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDropDownBoxToModule = /*#__PURE__*/(() => {
  class DxoDropDownBoxToModule {
    /** @nocollapse */static ɵfac = function DxoDropDownBoxToModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownBoxToModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDropDownBoxToModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDropDownBoxToComponent]
    });
  }
  return DxoDropDownBoxToModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiDropDownBoxToolbarItemComponent = /*#__PURE__*/(() => {
  class DxiDropDownBoxToolbarItemComponent extends CollectionNestedOption {
    renderer;
    document;
    element;
    get cssClass() {
      return this._getOption('cssClass');
    }
    set cssClass(value) {
      this._setOption('cssClass', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get html() {
      return this._getOption('html');
    }
    set html(value) {
      this._setOption('html', value);
    }
    get locateInMenu() {
      return this._getOption('locateInMenu');
    }
    set locateInMenu(value) {
      this._setOption('locateInMenu', value);
    }
    get location() {
      return this._getOption('location');
    }
    set location(value) {
      this._setOption('location', value);
    }
    get menuItemTemplate() {
      return this._getOption('menuItemTemplate');
    }
    set menuItemTemplate(value) {
      this._setOption('menuItemTemplate', value);
    }
    get options() {
      return this._getOption('options');
    }
    set options(value) {
      this._setOption('options', value);
    }
    get showText() {
      return this._getOption('showText');
    }
    set showText(value) {
      this._setOption('showText', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get toolbar() {
      return this._getOption('toolbar');
    }
    set toolbar(value) {
      this._setOption('toolbar', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get widget() {
      return this._getOption('widget');
    }
    set widget(value) {
      this._setOption('widget', value);
    }
    get _optionPath() {
      return 'toolbarItems';
    }
    constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
      super();
      this.renderer = renderer;
      this.document = document;
      this.element = element;
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      templateHost.setHost(this);
    }
    setTemplate(template) {
      this.template = template;
    }
    ngAfterViewInit() {
      extractTemplate(this, this.element, this.renderer, this.document);
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiDropDownBoxToolbarItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDropDownBoxToolbarItemComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiDropDownBoxToolbarItemComponent,
      selectors: [["dxi-drop-down-box-toolbar-item"]],
      inputs: {
        cssClass: "cssClass",
        disabled: "disabled",
        html: "html",
        locateInMenu: "locateInMenu",
        location: "location",
        menuItemTemplate: "menuItemTemplate",
        options: "options",
        showText: "showText",
        template: "template",
        text: "text",
        toolbar: "toolbar",
        visible: "visible",
        widget: "widget"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost, {
        provide: PROPERTY_TOKEN_toolbarItems,
        useExisting: DxiDropDownBoxToolbarItemComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function DxiDropDownBoxToolbarItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      dependencies: [DxIntegrationModule],
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
  return DxiDropDownBoxToolbarItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiDropDownBoxToolbarItemModule = /*#__PURE__*/(() => {
  class DxiDropDownBoxToolbarItemModule {
    /** @nocollapse */static ɵfac = function DxiDropDownBoxToolbarItemModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDropDownBoxToolbarItemModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiDropDownBoxToolbarItemModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiDropDownBoxToolbarItemComponent]
    });
  }
  return DxiDropDownBoxToolbarItemModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DxiDropDownBoxButtonComponent, DxiDropDownBoxButtonModule, DxiDropDownBoxToolbarItemComponent, DxiDropDownBoxToolbarItemModule, DxoDropDownBoxAnimationComponent, DxoDropDownBoxAnimationModule, DxoDropDownBoxAtComponent, DxoDropDownBoxAtModule, DxoDropDownBoxBoundaryOffsetComponent, DxoDropDownBoxBoundaryOffsetModule, DxoDropDownBoxCollisionComponent, DxoDropDownBoxCollisionModule, DxoDropDownBoxDropDownOptionsComponent, DxoDropDownBoxDropDownOptionsModule, DxoDropDownBoxFromComponent, DxoDropDownBoxFromModule, DxoDropDownBoxHideComponent, DxoDropDownBoxHideModule, DxoDropDownBoxMyComponent, DxoDropDownBoxMyModule, DxoDropDownBoxOffsetComponent, DxoDropDownBoxOffsetModule, DxoDropDownBoxOptionsComponent, DxoDropDownBoxOptionsModule, DxoDropDownBoxPositionComponent, DxoDropDownBoxPositionModule, DxoDropDownBoxShowComponent, DxoDropDownBoxShowModule, DxoDropDownBoxToComponent, DxoDropDownBoxToModule };
